import ModalDevice from 'views/MerchantProfile/Main/Buttons/ModalDevice'
import ModalIdentification from 'views/MerchantProfile/Main/Buttons/ModalIdentification'
import ModalMembership from 'views/MerchantProfile/Main/Buttons/ModalMembership'
import ModalBankAccounts from 'views/MerchantProfile/Main/Buttons/ModalBankAccounts'
import {
  accessControlSubNavigation,
  accessControlSubNavigationWithUserTypes,
} from 'setups/controller'
import { projectClient } from 'constants/project'

export const MerchantModalModulesData = [
  {
    module: 'Identification Create',
    label: 'Ident',
    value: '1',
    route: {
      title: 'identifications create',
      path: {
        path: '',
        permissionIds: [],
      },
    },
    Modal: ModalIdentification,
  },
  {
    module: 'Device Create',
    label: 'Devices',
    value: '2',
    route: {
      title: 'devices create',
      path: {
        path: '',
        permissionIds: [],
      },
    },
    Modal: ModalDevice,
  },
  {
    module: 'Membership Create',
    label: 'Membership',
    value: '3',
    route: {
      title: 'membership create',
      path: {
        path: '',
        permissionIds: [],
      },
    },
    Modal: ModalMembership,
  },
  {
    module: 'Bank Accounts Create',
    label: 'Bank Accounts',
    value: '4',
    route: {
      title: 'bank accounts create',
      path: {
        path: '',
        permissionIds: [],
      },
    },
    Modal: ModalBankAccounts,
  },
]

export const MERCHANTMODALNAVIGATION_OLD = accessControlSubNavigation(
  projectClient,
  MerchantModalModulesData,
  'merchant'
)

export const MERCHANTMODALNAVIGATION = accessControlSubNavigationWithUserTypes({
  projectClient,
  navModules: MerchantModalModulesData,
  navModule: 'merchant',
  userType: 'display_user',
  isTempBypass: true,
})
